import { render, staticRenderFns } from "./invChange.vue?vue&type=template&id=2f8d8897"
import script from "./invChange.vue?vue&type=script&lang=js"
export * from "./invChange.vue?vue&type=script&lang=js"
import style0 from "./invChange.vue?vue&type=style&index=0&id=2f8d8897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports